<template>
  <select-response-auto-complete
    v-bind="$attrs"
    :model="model"
    searchAllColumns
    api="Stocks/GetAllDynamic"
    :selected="selected"
    :fields="{id: 'id', title: 'supplierCompanyName'}"
    :columns="columns"
    :orderBy="{ fields: 'supplierCompany.name', order: 'desc'}"
    v-on="$listeners"
  >
  </select-response-auto-complete>
</template>

<script>
export default {
  name: 'Index',
  props: {
    model: {
      required: true
    }
  },
  computed: {
    selected () {
      return [
        'id', 'supplierCompany.name as supplierCompanyName', 'partPrice,priceCurrency.title as priceCurrencyTitle',
        'ownerCompany.name as ownerCompanyName', 'condition.title as conditionTitle'
      ].join(',')
    },
    columns () {
      return [
        { title: this.L10n('supplier-company'), value: 'supplierCompanyName', type: 'string', originField: 'supplierCompany.name' },
        {
          title: this.L10n('price'),
          // eslint-disable-next-line
          template: "${data.partPrice ? data.partPrice: ''} ${data.priceCurrencyTitle ? data.priceCurrencyTitle: ''}",
          type: 'number',
          originField: 'partPrice'
        },
        { title: this.L10n('owner-company'), value: 'ownerCompanyName', type: 'string', originField: 'ownerCompany.name' },
        { title: this.L10n('condition'), value: 'conditionTitle', type: 'string', originField: 'condition.title' }
      ]
    }
  }
}
</script>
